import { render, staticRenderFns } from "./ajuste-anual-inflacion.vue?vue&type=template&id=720db059&lang=html&"
import script from "./ajuste-anual-inflacion.vue?vue&type=script&lang=js&"
export * from "./ajuste-anual-inflacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports